import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth';
import { isSuperAdmin } from 'src/app/shared/constants/super-admin.constants';
import * as icons from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {

  icons = icons;

  constructor(
    public authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Check if the current user is a super admin.
   * Used to conditionally show the Super Admin link in the sidebar.
   */
  get isSuperAdmin(): boolean {
    return isSuperAdmin(this.authService.userData?.email);
  }

}

